import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: any = {
    promptId: '',
    prompt: '',
    category: '',
    model: ''
};

const promptSelectionSlice = createSlice({
    name: 'promptData',
    initialState,
    reducers: {
        setPromptData(state, action: PayloadAction<any>) {
            return { ...state, ...action.payload };
        }
    }
});

export const { setPromptData } = promptSelectionSlice.actions;

export default promptSelectionSlice.reducer;
